export enum SettingKey {
    numberOngoingOfferRetroactiveDays = 'numberOngoingOfferRetroactiveDays',
    offerRecommendationModalTimeIntervalDays = 'offerRecommendationModalTimeIntervalDays',
    askingForTrackingConsentTimeIntervalMonths = 'askingForTrackingConsentTimeIntervalMonths',
    preRegistrationTwoGroupAbTestSettings = 'preRegistrationTwoGroupAbTestSettings',
    adBlockerFaqLink = 'adBlockerFaqLink',
    shouldUseIntercomWhenLoggedOutOnWebApp = 'shouldUseIntercomWhenLoggedOutOnWebApp',
    productDiscoveryUserMessageSuggestionsByRegion = 'productDiscoveryUserMessageSuggestionsByRegion',
}

export interface Setting {
    __typename?: 'Setting';
    settingKey: SettingKey;
    value: string;
}

export const dataIdFromSetting = (setting: Setting) => {
    return `Setting:${setting.settingKey}`;
};
